const typedObjectEntries = <T>(source: T) =>
  Object.entries(source) as [keyof T, T[keyof T]][];

export { typedObjectEntries };
